<template>
  <div ref="statusLine" style="height: 100%">
    <v-card
      v-resize="onResize"
      class="mr-2"
      style="width: 300px; height: 100%; border-radius: 10px"
      fill-height
    >
      <v-card-text ref="statusTitle" class="text-xs-center primary lighten-3"
        >{{ value.text }} ({{ users.length }} Person)</v-card-text
      >
      <div ref="usersContainer" style="overflow-y: auto" :style="{ height: contentHeight + 'px' }">
        <div ref="users">
          <template v-for="(user, index) in users">
            <funnel-user
              :funnel="value.value"
              :value="user"
              :key="index + '_' + user.first_name"
              @onChangeUser="onChangeUser"
            ></funnel-user>
            <v-divider :key="index + '_' + user.first_name + '_divider'"></v-divider>
          </template>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import FunnelUser from './FunnelUser'
export default {
  props: ['value', 'data'],
  components: {
    FunnelUser
  },
  data() {
    return {
      users: [],
      contentHeight: 0
    }
  },
  mounted() {
    var users = this.data.filter((el) => {
      return el.status == this.value.value
    })
    this.users = users
  },
  methods: {
    onChangeUser(payload) {
      this.$emit('onMoveToAnotherLine', payload)
      // var index = this.users.findIndex(el => {
      //   return el.id == payload.id
      // })
      // if (index != -1) {
      //   if (payload.status != this.value.value) {
      //   } else {
      //     this.$set(this.users, index, payload)
      //   }
      // }
    },
    onResize: function () {
      this.contentHeight = this.$refs.statusLine.clientHeight - this.$refs.statusTitle.clientHeight
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/FunnelLine.vue